import React from "react";
import "./Skills.css";
import Frotend from "./Frotend";
import Backend from "./Backend";
import Lenguajes from "./Lenguajes";
import DevOps from "./DevOps";
import AITools from "./AITools";
import { useSelector } from "react-redux";

function Skills() {
  const es_en = useSelector((state) => state.translation);

  return (
    <section className="skills section reveal" id="skills">
      <h2 className="section__title">{es_en ? "Skills" : "Habilidades"}</h2>
      <span className="section__subtitle">
        {es_en ? "My technical level" : "Habilidades Técnicas"}
      </span>

      <div className="skills__container container grid ">
        <Frotend />
        <Backend />
        <DevOps />
        <Lenguajes />
        <AITools />
      </div>
    </section>
  );
}

export default Skills;
